import Layout from '@/views/Layout/index.vue'
const SettingPage = () => import('@/views/SettingPage/index.vue')
const OrgPage = () => import('@/views/SettingPage/Org/index.vue')
const RolePage = () => import('@/views/SettingPage/Role/index.vue')
const Employee = () => import('@/views/SettingPage/Employee/index.vue')
// const Base = () => import('@/views/SettingPage/Base/index.vue')
const Tags = () => import('@/views/SettingPage/Tags/index.vue')
const Credits = () => import('@/views/SettingPage/Credits/index.vue')
const End = () => import('@/views/SettingPage/End/index.vue')
// const Booking = () => import('@/views/SettingPage/Booking/index.vue')
const  SchoolManagement = () =>import('@/views/SettingPage/SchoolManagement/index.vue')
const CommentSettings = ()=>import('@/views/SettingPage/CommentSettings/index.vue')
const BasicSettings = ()=>import('@/views/SettingPage/BasicSettings/index.vue')
const Base = ()=>import('@/views/SettingPage/BasicSettings/Base/index.vue')
const  Booking = ()=>import('@/views/SettingPage/BasicSettings/Booking/index.vue')
const SetOrder = ()=>import('@/views/SettingPage/BasicSettings/SetOrder/index.vue')
const SetNotifications = ()=>import('@/views/SettingPage/BasicSettings/SetNotifications/index.vue')
const AttendanceSettings = ()=>import('@/views/SettingPage/BasicSettings/AttendanceSettings/index.vue')
const HolidaySettings = ()=>import('@/views/SettingPage/BasicSettings/HolidaySettings/index.vue')
export default {
  path: '/setting',
  component: Layout,
  children: [
    {
      path: '',
      component: SettingPage,
      children: [
        {
          path: '',
          component: OrgPage,
        },{
          path:'/setting/base',
          component:BasicSettings,
          children:[
              {
                path:'/setting/base/base',
                component:Base
              },{
                path:'/setting/base/booking',
                component:Booking
              },{
                path:'/setting/base/setOrder',
                component:SetOrder
              },{
                path:'/setting/base/SetNotifications',
                component:SetNotifications
              },{
                path:'/setting/base/AttendanceSettings',
                component:AttendanceSettings
            },{
              path:'/setting/base/holidaySettings',
              component:HolidaySettings
            }
          ]
        },
        {
          path: 'role',
          component: RolePage,
        },
        {
          path: 'employee',
          component: Employee,
        },
        // {
        //   path: 'base',
        //   component: Base,
        // },
        {
          path: 'tags',
          component: Tags,
        },
        {
          path: 'credits',
          component: Credits,
        },
        {
          path: 'end',
          component: End,
        },{
          path: 'booking',
          component: Booking,
        },{
        path:'schoolmanagement',
        component:SchoolManagement
        },{
          path:'commentSettings',
          component:CommentSettings
        },
      ]
    }
  ]
}
